export default __webpack_public_path__ + "static/thailand-d85c85fb3d8dd0898d61f761f4e5f1f6.svg";